/* Aventurx — Scheda speciale di un prodotto (sections/axr-showcase.liquid).
   Fa comparire i blocchi mentre si scorre, cambia colore e vista del prodotto, e i pulsanti d'acquisto
   portano alla scelta di colore e taglia in cima alla pagina (scegliendo anche il colore). */
(function () {
  'use strict';

  function buyBox() {
    return document.querySelector('.product-form[data-product-id]') || document.querySelector('.product-detail');
  }

  function scrollToBuy() {
    var box = buyBox();
    if (!box) return false;
    var top = box.getBoundingClientRect().top + window.pageYOffset - 90;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
    return true;
  }

  // sceglie il colore nel selettore vero della pagina (bottoni del tema); false se non c'è
  function pickColor(optionName, value) {
    var sets = document.querySelectorAll('.option-selector[data-option]');
    for (var i = 0; i < sets.length; i++) {
      if (sets[i].getAttribute('data-option') !== optionName) continue;
      var inputs = sets[i].querySelectorAll('input.js-option');
      for (var j = 0; j < inputs.length; j++) {
        if (inputs[j].value === value) {
          if (!inputs[j].checked) inputs[j].click();
          return true;
        }
      }
    }
    return false;
  }

  function initReveal(root) {
    var items = root.querySelectorAll('.axr-sc-reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < items.length; i++) items[i].classList.add('is-in');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    for (var k = 0; k < items.length; k++) io.observe(items[k]);
  }

  function initStage(stage) {
    var items = stage.querySelectorAll('.axr-sc-stage__item');
    var panel = stage.closest('[data-axr-sc-panel]');
    var thumbs = panel ? panel.querySelectorAll('[data-axr-sc-go]') : [];
    var n = items.length;
    var cur = 0;
    if (n < 2) return { go: function () {} };

    function go(i) {
      cur = (i + n) % n;
      for (var a = 0; a < n; a++) items[a].classList.toggle('is-on', a === cur);
      for (var b = 0; b < thumbs.length; b++) {
        var on = Number(thumbs[b].getAttribute('data-axr-sc-go')) === cur;
        thumbs[b].classList.toggle('is-on', on);
        thumbs[b].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      // carica subito la foto della vista scelta (le altre sono «lazy»)
      var img = items[cur].querySelector('img');
      if (img && img.loading === 'lazy') img.loading = 'eager';
    }

    stage.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-axr-sc-step]');
      if (btn) go(cur + Number(btn.getAttribute('data-axr-sc-step')));
    });
    for (var t = 0; t < thumbs.length; t++) {
      thumbs[t].addEventListener('click', function () { go(Number(this.getAttribute('data-axr-sc-go'))); });
    }

    // scorrere col dito cambia vista
    var x0 = null, y0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      x0 = y0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) go(cur + (dx < 0 ? 1 : -1));
    }, { passive: true });

    return { go: go };
  }

  function initColors(box) {
    var option = box.getAttribute('data-option');
    var tabs = box.querySelectorAll('[data-axr-sc-color]');
    var panels = box.querySelectorAll('[data-axr-sc-panel]');
    var stages = box.querySelectorAll('[data-axr-sc-stage]');
    for (var s = 0; s < stages.length; s++) initStage(stages[s]);

    function show(i) {
      for (var a = 0; a < tabs.length; a++) {
        var on = Number(tabs[a].getAttribute('data-axr-sc-color')) === i;
        tabs[a].classList.toggle('is-on', on);
        tabs[a].setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on && tabs[a].scrollIntoView && tabs[a].parentNode.scrollWidth > tabs[a].parentNode.clientWidth) {
          tabs[a].parentNode.scrollTo({ left: tabs[a].offsetLeft - 16, behavior: 'smooth' });
        }
      }
      for (var b = 0; b < panels.length; b++) {
        var p = panels[b];
        var vis = Number(p.getAttribute('data-axr-sc-panel')) === i;
        p.hidden = !vis;
        p.classList.toggle('is-on', vis);
        if (vis) {
          var first = p.querySelector('.axr-sc-stage__item.is-on img');
          if (first && first.loading === 'lazy') first.loading = 'eager';
        }
      }
    }

    for (var t = 0; t < tabs.length; t++) {
      tabs[t].addEventListener('click', function () { show(Number(this.getAttribute('data-axr-sc-color'))); });
    }

    box.addEventListener('click', function (e) {
      var a = e.target.closest('[data-axr-sc-pick]');
      if (!a) return;
      if (pickColor(option, a.getAttribute('data-axr-sc-pick')) && scrollToBuy()) e.preventDefault();
    });

    // se il colore cambia in cima alla pagina, la scheda speciale mostra lo stesso colore
    document.addEventListener('change', function (e) {
      var el = e.target;
      if (!el || !el.classList || !el.classList.contains('js-option')) return;
      var set = el.closest('.option-selector[data-option]');
      if (!set || set.getAttribute('data-option') !== option) return;
      for (var i = 0; i < tabs.length; i++) {
        var name = tabs[i].querySelector('.axr-sc-colors__name');
        if (name && name.textContent.trim() === el.value) { show(Number(tabs[i].getAttribute('data-axr-sc-color'))); break; }
      }
    });
  }

  function init(root) {
    if (root.dataset.axrScReady) return;
    root.dataset.axrScReady = '1';
    root.classList.add('is-js');
    initReveal(root);
    var colors = root.querySelectorAll('[data-axr-sc-colors]');
    for (var c = 0; c < colors.length; c++) initColors(colors[c]);
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-axr-sc-buy]');
      if (a && scrollToBuy()) e.preventDefault();
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-axr-sc]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // editor del tema: la sezione può essere ricaricata
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-axr-sc]');
    if (r) init(r);
  });
})();
